<template>
	<div class="flex w-full justify-center px-4">
		<div class="w-full max-w-8xl" :data-home-section="section.id" v-safe-html="section.html" @click="followSiteLink" />
	</div>
</template>

<script>
// A section an admin wrote on Storefront › Home page. The HTML was sanitized
// when it was saved and is sanitized again by v-safe-html. The CSS arrives
// scoped to [data-home-section="<id>"], so it only styles this section.
export default {
	props: {
		section: { type: Object, required: true },
	},
	data() {
		return { styleEl: null }
	},
	watch: {
		'section.css'() {
			this.syncCss()
		},
	},
	mounted() {
		this.syncCss()
	},
	unmounted() {
		this.styleEl?.remove()
	},
	methods: {
		syncCss() {
			if (!this.section.css) {
				this.styleEl?.remove()
				this.styleEl = null
				return
			}
			if (!this.styleEl) {
				this.styleEl = document.createElement('style')
				this.styleEl.setAttribute('data-home-section', this.section.id)
				document.head.appendChild(this.styleEl)
			}
			this.styleEl.textContent = this.section.css
		},
		// Links to store pages go through the router instead of reloading the app.
		followSiteLink(event) {
			if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
			const link = event.target.closest?.('a[href]')
			if (!link || link.target === '_blank') return
			const href = link.getAttribute('href')
			if (!href?.startsWith('/') || href.startsWith('//')) return
			event.preventDefault()
			this.$router.push(href)
		},
	},
}
</script>
